<template>
  <!--  https://jsfiddle.net/bogdanb86/3dr9ktxc/28/  -->
  <div class="row f-row" style="font-size: 0.8rem;">
    <div class="col col-auto text-right vert-align">
      <span class="mr-1 align-middle">{{ labelTxt }}</span>
      <span class="mr-1 align-middle" v-show="showDates">{{
        dates[zoomNew[0]] | formatDate
      }}</span>
    </div>
    <div class="col col-cx ml-2 mr-2">
      <Slider
        v-model="zoomNew"
        :step="1"
        :range="true"
        :min="0"
        :max="dates.length - 1"
        @change="onUserSlider"
        @slideEnd="onUserSliderEnd"
      />
    </div>
    <div class="col col-auto vert-align" v-show="showDates">
      <span class="ml-1 mr-2 align-middle">{{
        dates[zoomNew[1]] | formatDate
      }}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Slider from "primevue/slider";

export default {
  name: "RangeSlider",
  components: {
    Slider,
  },
  props: {
    dates: { required: true },
    labelTxt: { required: true },
    maxIdx: { required: true, default: 0 },
    minIdx: { required: true, default: 0 },
    showDates: { required: false, type: Boolean, default: true },
  },
  data() {
    return {
      zoomOld: [0, 1],
      zoomNew: [0, 1],
    };
  },
  computed: {},
  watch: {
    minIdx(val) {
      this.zoomNew.splice(0, 1, val);
      this.zoomOld.splice(0, 1, val);
    },
    maxIdx(val) {
      this.zoomNew.splice(1, 1, val);
      this.zoomOld.splice(1, 1, val);
    },
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YY");
      }
    },
  },
  mounted() {
    this.zoomNew.splice(0, 1, this.minIdx);
    this.zoomNew.splice(1, 1, this.maxIdx);
    this.zoomOld = JSON.parse(JSON.stringify(this.zoomNew));
  },
  methods: {
    onUserSlider(event) {
      if (event[0] !== this.zoomOld[0]) {
        this.onUserSliderMin(event[0]);
        this.onUserSliderMinChange(event[0]);
      } else if (event[1] !== this.zoomOld[1]) {
        this.onUserSliderMax(event[1]);
        this.onUserSliderMaxChange(event[1]);
      }
      this.zoomOld = JSON.parse(JSON.stringify(event));
    },
    onUserSliderEnd(event) {
      if (event[0] !== this.zoomOld[0]) {
        this.onUserSliderMinChange(event[0]);
      } else if (event[1] !== this.zoomOld[1]) {
        this.onUserSliderMaxChange(event[1]);
      }
      this.zoomOld = JSON.parse(JSON.stringify(event));
    },
    onUserSliderMin(val) {
      this.$emit("eventOnMinRange", val);
    },
    onUserSliderMax(val) {
      this.$emit("eventOnMaxRange", val);
    },
    onUserSliderMinChange(val) {
      this.$emit("eventOnMinRangeChange", val);
    },
    onUserSliderMaxChange(val) {
      this.$emit("eventOnMaxRangeChange", val);
    },
  },
};
</script>
